"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertedRepCodesOptions = exports.convertCode = void 0;
const ramda_1 = require("ramda");
const convertCode = (code) => {
    return {
        value: code === null || code === void 0 ? void 0 : code.id,
        label: (0, ramda_1.has)('sourceName', code) && code.sourceName.length ? `${code === null || code === void 0 ? void 0 : code.code}, ` : `${code === null || code === void 0 ? void 0 : code.code}`,
        source: (0, ramda_1.has)('sourceName', code) ? code === null || code === void 0 ? void 0 : code.sourceName : ''
    };
};
exports.convertCode = convertCode;
const sortByNameCaseInsensitive = (0, ramda_1.sortBy)((0, ramda_1.compose)(ramda_1.toLower, (0, ramda_1.prop)('label')));
const convertedRepCodesOptions = (repCodesStructure, codes = new Map([])) => {
    if (!repCodesStructure) {
        return [];
    }
    //used Map to remove duplicates
    const convertedCodes = repCodesStructure.reduce((acc, code) => {
        return acc.set(code.id, (0, exports.convertCode)(code));
    }, new Map([]));
    return sortByNameCaseInsensitive(Array.from(convertedCodes.values()));
};
exports.convertedRepCodesOptions = convertedRepCodesOptions;
